import { render, staticRenderFns } from "./_inputRow.vue?vue&type=template&id=63e620b5&scoped=true"
import script from "./_inputRow.vue?vue&type=script&lang=js"
export * from "./_inputRow.vue?vue&type=script&lang=js"
import style0 from "./_inputRow.vue?vue&type=style&index=0&id=63e620b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e620b5",
  null
  
)

export default component.exports